import { Http } from '@/services';
import { getJWTToken, tokenIsValid } from '@/services/auth';
import store from '@/store';

let loadedInitialUser = false;

export default async (to, from, next) => {
  if (store.state.auth.user) {
    return next();
  }

  if (!loadedInitialUser) {
    loadedInitialUser = true;

    const token = getJWTToken();

    if (tokenIsValid(token)) {
      Http.setAuthenticationToken(token);
      try {
        const { user } = await Http.get('api/auth/user');
        store.commit('auth/setUser', user);
        return next();
      } catch {
        // remove Token
        Http.setAuthenticationToken(null);
      }
    }
  }

  // if the user us a guest, we will let them in
  if (to.meta.auth === 'guest') {
    return next();
  }
  // other wise we will take the user to the login page
  return next({ name: 'auth.admin' });
};
